import RechargeRecord from './recharge_record.vue'

export default {
    name: 'rechargeRecord',
    path: 'rechargeRecord',
    component: RechargeRecord
}
